import { render, staticRenderFns } from "./AccelerometerWidget.vue?vue&type=template&id=37cfdffb&scoped=true&"
import script from "./AccelerometerWidget.vue?vue&type=script&lang=ts&"
export * from "./AccelerometerWidget.vue?vue&type=script&lang=ts&"
import style0 from "./AccelerometerWidget.vue?vue&type=style&index=0&id=37cfdffb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cfdffb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VIcon,VRow,VTooltip})
